import { render, staticRenderFns } from "./MoveList.vue?vue&type=template&id=2568d5d9"
import script from "./MoveList.vue?vue&type=script&lang=js"
export * from "./MoveList.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports